import { render, staticRenderFns } from "./Paso1SA.vue?vue&type=template&id=5932f12a&"
import script from "./Paso1SA.vue?vue&type=script&lang=js&"
export * from "./Paso1SA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports